var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('i18n',{attrs:{"path":"parent-reference-line-item-id.description","tag":_vm.tag}},[_c('span',{attrs:{"id":"parent-reference-line-item-id"}},[_vm._v(_vm._s(_vm.label))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }